import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgArrowBack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M2.167 12h9a4 4 0 0 0 0-8H4.832" stroke="#007AFF" />
    <path d="M8.167.667 4.834 4l3.333 3.333" stroke="#007AFF" />
  </svg>
);
const Memo = memo(SvgArrowBack);
export default Memo;
